import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import useApi from "../../core/customhook/useApi";
import axios from "axios";
import { apibaseurl, jwttoken } from "../../environment";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import Loader from "../../core/common/selfLoder";
import { all_routes } from "../router/all_routes";
interface DataType {
  created_date: string;
  noofcards: number;
}

interface SelfHelfTabRecord {
  type_id?: string;
  type_name?: string;
}
interface SelfHelpTab {
  success?: boolean;
  message?: string;
  statusCode?: number;
  data?: SelfHelfTabRecord[];
}
interface officeAddressData {
  address_id: string;
  address_name: string;
}
interface officeAddress {
  success?: boolean;
  message?: string;
  statusCode?: number;
  data?: officeAddressData[];
}
interface idCardLossReasonData {
  reason_id: string;
  reason: string;
}
interface idCardLossReason {
  success?: boolean;
  message?: string;
  statusCode?: number;
  data?: idCardLossReasonData[];
}
interface meetingRoomData {
  room_id: string;
  room_name: string;
}
interface meetingRoom {
  success?: boolean;
  message?: string;
  statusCode?: number;
  data?: meetingRoomData[];
}

interface EmployeeProfile {
  employee_name: string;
  designation: string;
  department: string;
  sub_department: string;
  email_id: string;
  contact_number: string;
  join_date: string;
  photo: string | null;
  work_location: string;
  employee_id: string;
  band: string;
}

interface EmployeeProfileMainRsponse {
  message: string;
  statusCode: number;
  success: boolean;
  data: EmployeeProfile;
}
const SelfHelp = () => {
  const [data1, setData1] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string | undefined>("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const businessCardModalRef = useRef<HTMLDivElement | null>(null);
  const businessCardModalRefEdit = useRef<HTMLDivElement | null>(null);
  const IdCardModalRefEdit = useRef<HTMLDivElement | null>(null);
  const BookModalRefEdit = useRef<HTMLDivElement | null>(null);
  const [selfHelpDataLoading, setSelfHelpDataLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const formatToLongDate = (dateString: string | null) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const {
    data: employeeData,
    loading: employeeLoading,
    error: employeeError,
  } = useApi<EmployeeProfileMainRsponse>("/api/get-profile-overview", {
    method: "GET",
    autoCall: true,
  });

  const columns1 = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <p className="fs-14 fw-medium d-flex align-items-center mb-0">
            {text}
          </p>
        </div>
      ),
      sorter: (a: any, b: any) => a.key - b.key,
    },
    {
      title: "Ticket No",
      dataIndex: "ticket_no",
      sorter: (a: any, b: any) => a.ticket_no.localeCompare(b.ticket_no),
    },
    {
      title: "Office Address",
      dataIndex: "office_address",
      sorter: (a: any, b: any) =>
        a.office_address.localeCompare(b.office_address),
    },
    {
      title: "No of Cards",
      dataIndex: "noofcards",
      sorter: (a: any, b: any) => a.noofcards - b.noofcards,
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      render: (text: string) => formatToLongDate(text),
      sorter: (a: DataType, b: DataType) => {
        const dateA = moment(a.created_date, "DD-MM-YYYY");
        const dateB = moment(b.created_date, "DD-MM-YYYY");
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0; // Sorting based on moment objects
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: String) => (
        <p
          className={`${
            text === "Open"
              ? "text-primary"
              : text === "In Progress"
                ? "text-info"
                : text === "On Hold"
                  ? "text-warning"
                  : text === "Closed"
                    ? "text-success"
                    : text === "Cancelled"
                      ? "text-danger"
                      : "text-danger"
          }`}
        >
          {text}
        </p>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isDisabled = record.status !== "Open";

        return (
          <div className="action-icon d-inline-flex">
            <div
              className={`me-2 ${isDisabled ? "disabled-link" : ""}`}
              onClick={() => {
                if (!isDisabled) setSelectedRowData(record);
              }}
              style={{
                color: isDisabled ? "gray" : "inherit",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              role="button"
              tabIndex={isDisabled ? -1 : 0}
              data-bs-toggle={isDisabled ? undefined : "modal"}
              data-bs-target={
                isDisabled ? undefined : "#editBusiness_Card_Request"
              }
              aria-disabled={isDisabled}
            >
              <i className="ti ti-edit" />
            </div>
          </div>
        );
      },
    },
  ];

  const columns2 = [
    {
      title: "SrNo",
      dataIndex: "key",
      render: (text: String) => (
        <div className="d-flex align-items-center">
          <p className="fs-14 fw-medium d-flex align-items-center mb-0">
            {text}
          </p>
        </div>
      ),
      sorter: (a: any, b: any) => a.key - b.key,
    },
    {
      title: "Ticket No",
      dataIndex: "ticket_no",
      sorter: (a: any, b: any) => a.ticket_no.localeCompare(b.ticket_no),
    },
    {
      title: "BloodGroup",
      dataIndex: "blood_group",
      sorter: (a: any, b: any) => a.blood_group.localeCompare(b.blood_group),
    },
    {
      title: "ReasonforRequest",
      dataIndex: "reason",
      sorter: (a: any, b: any) => a.reason.localeCompare(b.reason),
    },
    {
      title: "CreatedDate",
      dataIndex: "created_date",
      render: (text: string) => formatToLongDate(text),
      sorter: (a: DataType, b: DataType) => {
        const dateA = moment(a.created_date, "DD-MM-YYYY");
        const dateB = moment(b.created_date, "DD-MM-YYYY");
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0; // Sorting based on moment objects
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: String) => (
        <p
          className={`${
            text === "Open"
              ? "text-primary"
              : text === "In Progress"
                ? "text-info"
                : text === "On Hold"
                  ? "text-warning"
                  : text === "Closed"
                    ? "text-success"
                    : text === "Cancelled"
                      ? "text-danger"
                      : "text-danger"
          }`}
        >
          {text}
        </p>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isDisabled = record.status !== "Open";

        return (
          <div className="action-icon d-inline-flex">
            <div
              className={`me-2 ${isDisabled ? "disabled-link" : ""}`}
              onClick={() => {
                if (!isDisabled) setSelectedRowData(record);
              }}
              style={{
                color: isDisabled ? "gray" : "inherit",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              role="button"
              tabIndex={isDisabled ? -1 : 0}
              data-bs-toggle={isDisabled ? undefined : "modal"}
              data-bs-target={isDisabled ? undefined : "#edit_id_Card_Request"}
              aria-disabled={isDisabled}
            >
              <i className="ti ti-edit" />
            </div>
          </div>
        );
      },
    },
  ];

  const columns3 = [
    {
      title: "SrNo",
      dataIndex: "key",
      sorter: (a: any, b: any) => a.key - b.key,
      render: (text: String) => (
        <div className="d-flex align-items-center">
          <p className="fs-14 fw-medium d-flex align-items-center mb-0">
            {text}
          </p>
        </div>
      ),
    },
    {
      title: "Meeting Room",
      dataIndex: "room_name",
      sorter: (a: any, b: any) => a.room_name.localeCompare(b.room_name),
    },
    {
      title: "Booking Date",
      dataIndex: "booking_date",
      sorter: (a: any, b: any) =>
        new Date(a.booking_date).getTime() - new Date(b.booking_date).getTime(),
      render: (text: string) => formatToLongDate(text),
    },
    {
      title: "Time",
      dataIndex: `totalTime`,
      sorter: (a: any, b: any) => {
        const timeA = a.totalTime.split(":").map(Number);
        const timeB = b.totalTime.split(":").map(Number);
        return timeA[0] * 60 + timeA[1] - (timeB[0] * 60 + timeB[1]);
      },
      render: (text: String) => <p>{text}</p>,
    },
    {
      title: "Purpose",
      dataIndex: "booking_purpose",
      sorter: (a: any, b: any) =>
        a.booking_purpose.localeCompare(b.booking_purpose),
      render: (text: String) => <p>{text}</p>,
    },
    {
      title: "CreatedDate",
      dataIndex: "created_date",
      render: (text: string) => formatToLongDate(text),
      sorter: (a: DataType, b: DataType) => {
        const dateA = moment(a.created_date, "DD-MM-YYYY");
        const dateB = moment(b.created_date, "DD-MM-YYYY");
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0; // Sorting based on moment objects
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      render: (text: String) => (
        <p
          className={`${
            text === "Pending" || text === "Cancelled"
              ? "text-danger"
              : "text-success"
          }`}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isDisabled = record.status !== "Pending";

        return (
          <div className="action-icon d-inline-flex">
            <div
              className={`me-2 ${isDisabled ? "disabled-link" : ""}`}
              onClick={() => {
                if (!isDisabled) setSelectedRowData(record);
              }}
              style={{
                color: isDisabled ? "gray" : "inherit",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              role="button"
              tabIndex={isDisabled ? -1 : 0}
              data-bs-toggle={isDisabled ? undefined : "modal"}
              data-bs-target={
                isDisabled ? undefined : "#edit_Book_meeting_room"
              }
              aria-disabled={isDisabled}
            >
              <i className="ti ti-edit" />
            </div>
          </div>
        );
      },
    },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const [activeFormTab, setActiveFormTab] = useState("Business Card Request");

  const leavetype = [
    {
      value: "Business Card Request",
      label: "Business Card Request",
      component: "first component",
    },
    {
      value: "ID Card Request",
      label: "ID Card Request",
      component: "second component",
    },
    {
      value: "Book Meeting Room",
      label: "Book Meeting Room",
      component: "third component",
    },
  ];
  const {
    data: selfHelpTabResponse,
    loading: selfHelpTabLoading,
    error: selfHelpTabError,
  } = useApi<SelfHelpTab>("/api/master/get-self-help-type", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (selfHelpTabResponse?.data && selfHelpTabResponse.data.length > 0) {
      setActiveTab(selfHelpTabResponse.data[0].type_id);
    }
  }, [selfHelpTabResponse]);

  const getSelfHelpData = async () => {
    try {
      setSelfHelpDataLoading(true);
      setData1([]);
      const response = await axios.post(
        `${apibaseurl}/api/get-self-help-data`,
        { type: activeTab },
        {
          headers: {
            Authorization: `Bearer ${jwttoken}`,
            "Content-Type": "application/json",
          },
        },
      );
      const responseData = response.data.data || [];
      console.log(responseData);
      const dataWithKeys = responseData.map((item: any, index: number) => {
        const startTime = item.start_time;
        const endTime = item.end_time;
        const totalTime =
          startTime && endTime ? `${startTime} - ${endTime}` : "";

        return {
          ...item,
          key: index + 1,
          totalTime,
        };
      });
      setData1(dataWithKeys);
    } catch (error) {
      console.error("Error fetching self-help data:", error);
    } finally {
      setSelfHelpDataLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab) {
      getSelfHelpData();
    }
  }, [activeTab]);

  const {
    data: officeAddressResponse,
    loading: officeAddressTabLoading,
    error: officeAddressTabError,
  } = useApi<officeAddress>("/api/master/get-office-address", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: idCardLossReasonResponse,
    loading: idCardLossReasonTabLoading,
    error: idCardLossReasonTabError,
  } = useApi<idCardLossReason>("/api/master/get-id-card-reason", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: meetingRoomResponse,
    loading: meetingRoomTabLoading,
    error: meetingRoomTabError,
  } = useApi<meetingRoom>("/api/master/get-meeting-room", {
    method: "GET",
    autoCall: true,
  });

  const [bussinessCardData, setBussinessCardData] = useState({
    emp_name: employeeData?.data.employee_name,
    email: employeeData?.data.email_id,
    phone: employeeData?.data.contact_number,
    address: "",
    numberofcard: "",
  });

  const [idCardData, setIdCardData] = useState({
    employee_id: employeeData?.data.employee_id,
    employee_name: employeeData?.data.employee_name,
    blood_group: "",
    emergency_no: employeeData?.data.contact_number,
    department: employeeData?.data.department,
    reason_id: "",
  });

  const [meetingRoomData, setMeetingRoomData] = useState({
    booking_date: "",
    start_time: "",
    end_time: "",
    booking_purpose: "",
    room_id: "",
  });

  const getInputDataBussinesscard = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setBussinessCardData({ ...bussinessCardData, [name]: value });
  };

  const getIdCardInputData = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const chnageValue = name === "blood_group" ? value.toUpperCase() : value;
    setIdCardData({ ...idCardData, [name]: chnageValue });
  };

  const getBookMeetingData = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setMeetingRoomData({ ...meetingRoomData, [name]: value });
  };

  const {
    data: businessCardResponse,
    loading: isSubmittingBusinessCard,
    error: submitBusinessCardError,
    callApi: submitBusinessCardApi,
  } = useApi("/api/business-card-request", {
    method: "POST",
    autoCall: false,
  });

  const submitBussinessCardRequest = async (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    const data = {
      employee_name: employeeData?.data.employee_name,
      email_id: employeeData?.data.email_id,
      phone_no: employeeData?.data.contact_number,
      office_add_id: bussinessCardData.address,
      noCards: bussinessCardData.numberofcard,
    };
    setLoading(true);
    try {
      const response = await submitBusinessCardApi(data);
      // setTimeout(() => {
      setLoading(false);
      Swal.fire({
        title: "Success!",
        text:
          response?.message || "Business card request submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      document.getElementById("closeBusinessCardModal")?.click();

      getSelfHelpData();
      // closeModalProperly(businessCardModalRef)
      setBussinessCardData({
        emp_name: "",
        email: "",
        phone: "",
        address: "",
        numberofcard: "",
      });

      form.classList.remove("was-validated");
      // }, 1500);
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text:
          submitBusinessCardError?.response?.data?.message ||
          "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: idCardResponse,
    loading: isSubmitting,
    error: submitError,
    callApi: submitIdCardApi,
  } = useApi("/api/id-card-request", {
    method: "POST",
    autoCall: false,
  });

  const submitIDCardRequest = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data = {
      employee_id: employeeData?.data.employee_id,
      employee_name: employeeData?.data.employee_name,
      blood_group: idCardData.blood_group,
      emergency_no: employeeData?.data.contact_number,
      department: employeeData?.data.department,
      reason_id: idCardData.reason_id,
    };

    const form = e.currentTarget;
    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    try {
      setLoading(true);
      const response = await submitIdCardApi(data);
      setLoading(false);
      Swal.fire({
        title: "Success!",
        text: response?.message || "ID card request submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      document.getElementById("closeBusinessCardModal")?.click();

      getSelfHelpData();
      setIdCardData({
        employee_id: "",
        employee_name: "",
        blood_group: "",
        emergency_no: "",
        department: "",
        reason_id: "",
      });

      form.classList.remove("was-validated");
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text:
          submitError?.response?.data?.message ||
          "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: meetingRoomResponseData,
    loading: isSubmittingMeetingRoom,
    error: meetingRoomError,
    callApi: submitMeetingRoomApi,
  } = useApi("/api/book-meeting-room", {
    method: "POST",
    autoCall: false,
  });

  const submitMeetingRoomRequest = async (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    try {
      setLoading(true);
      const response = await submitMeetingRoomApi(meetingRoomData);
      setLoading(false);
      console.log(response, "response");
      Swal.fire({
        title: "Success!",
        text:
          response?.message ||
          "Meeting room booking request submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      document.getElementById("closeBusinessCardModal")?.click();

      getSelfHelpData();

      setMeetingRoomData({
        booking_date: "",
        start_time: "",
        end_time: "",
        booking_purpose: "",
        room_id: "",
      });

      form.classList.remove("was-validated");
    } catch (error: any) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: updateBusinessCardResponse,
    loading: isUpdatingBusinessCard,
    error: updateBusinessCardError,
    callApi: updateBusinessCardApi,
  } = useApi("/api/update-business-card-request", {
    method: "POST",
    autoCall: false,
  });

  const upDateBussinessCard = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    const payload = {
      ticket_no: selectedRowData.ticket_no,
      employee_name: selectedRowData.employee_name,
      email_id: selectedRowData.email_id,
      phone_no: selectedRowData.phone,
      office_add_id: selectedRowData.office_address_id,
      noCards: selectedRowData.noofcards,
    };

    try {
      setLoading(true);
      const response = await updateBusinessCardApi(payload);

      getSelfHelpData();
      // closeModalProperly(businessCardModalRefEdit) // Uncomment if needed
      setLoading(false);
      Swal.fire({
        title: "Success!",
        text: response?.message || "Business card updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      document.getElementById("editBusinessCard")?.click();
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text:
          updateBusinessCardError?.response?.data?.message ||
          "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: updateIdCardResponse,
    loading: isUpdatingIdCard,
    error: updateIdCardError,
    callApi: updateIdCardApi,
  } = useApi("/api/update-id-card-request", {
    method: "POST",
    autoCall: false,
  });

  const upDateIdCard = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    const payload = {
      ticket_no: selectedRowData.ticket_no,
      employee_id: selectedRowData.emp_id,
      employee_name: selectedRowData.employee_name,
      blood_group: selectedRowData.blood_group.toUpperCase(),
      emergency_no: selectedRowData.emergency_no,
      department: selectedRowData.department,
      reason_id: selectedRowData.reason_id,
    };

    try {
      setLoading(true);
      const response = await updateIdCardApi(payload);

      getSelfHelpData();
      // closeModalProperly(IdCardModalRefEdit) // Uncomment if needed
      setLoading(false);
      Swal.fire({
        title: "Success!",
        text: response?.message || "ID card updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      document.getElementById("editIDCard")?.click();
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text:
          updateIdCardError?.response?.data?.message ||
          "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: updateMeetingRoomResponse,
    loading: isUpdatingMeetingRoom,
    error: updateMeetingRoomError,
    callApi: updateMeetingRoomApi,
  } = useApi("/api/update-book-meeting-room", {
    method: "POST",
    autoCall: false,
  });

  const upDateMeetingRoom = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    const payload = {
      booking_id: selectedRowData.ID,
      booking_date: selectedRowData.booking_date,
      start_time: selectedRowData.start_time,
      end_time: selectedRowData.end_time,
      booking_purpose: selectedRowData.booking_purpose,
      room_id: selectedRowData.room_id,
    };

    try {
      setLoading(true);
      const response = await updateMeetingRoomApi(payload);
      console.log(response);
      getSelfHelpData();
      setLoading(false);
      if (response?.statusCode === 201) {
        Swal.fire({
          title: "Success!",
          text: response.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        document.getElementById("editBookMeeting")?.click();
      } else {
        Swal.fire({
          title: "Error!",
          text: response.message || "Something went wrong.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text:
          updateMeetingRoomError?.response?.data?.message ||
          "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  return (
    <>
      <Loader
        loading={
          employeeLoading ||
          selfHelpTabLoading ||
          // loading ||
          officeAddressTabLoading ||
          idCardLossReasonTabLoading ||
          meetingRoomTabLoading
          // selfHelpDataLoading
        }
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Self Help </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Self Help
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center justify-content-end flex-wrap ">
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_leaves"
                  className="btn btn-primary custom_button d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Request
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* Leaves Info */}
          <div className="card">
            <div className="card-body">
              <div className="row">
                {selfHelpTabResponse?.data?.map((item, index) => (
                  <div className="col-xl-3 col-sm-6 " key={index}>
                    <div
                      className={`card my-2 ${
                        index == 0
                          ? "bg-black-le"
                          : index == 1
                            ? "bg-blue-le"
                            : "bg-purple-le"
                      }`}
                      style={
                        activeTab === item.type_id
                          ? {
                              boxShadow: "1px 1px 5px 1px rgb(185, 185, 185)",
                              borderColor: "#E3520D",
                            }
                          : {}
                      }
                    >
                      <div
                        className="card-body my-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveTab(item.type_id)}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="text-start">
                            <h5 className="mb-1">{item.type_name}</h5>
                            {/* <h4>{data1.length}</h4> */}
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-2">
                              <span className="avatar avatar-md d-flex">
                                <i className="ti ti-calendar-event fs-32" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {activeTab == "SH20251001" && (
            <div className="card card-body p-0 mt-3">
              <Table
                dataSource={data1}
                columns={columns1}
                Selection={false}
                showSearchInput={true}
              />
            </div>
          )}
          {activeTab == "SH20251002" && (
            <div className="card card-body p-0 mt-3">
              <Table
                dataSource={data1}
                columns={columns2}
                Selection={false}
                showSearchInput={true}
              />
            </div>
          )}
          {activeTab == "SH20251003" && (
            <div className="card card-body p-0 mt-3">
              <Table
                dataSource={data1}
                columns={columns3}
                Selection={false}
                showSearchInput={true}
              />
            </div>
          )}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Form */}

      <div className="modal fade" id="add_leaves" ref={businessCardModalRef}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Request</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeBusinessCardModal"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            {/* <form> */}
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3 ">
                    <div
                      className="mb-3"
                      style={{ overflowX: "auto", overflowY: "hidden" }}
                    >
                      <ul
                        className="nav nav-tabs flex-nowrap mb-0 mb-sm-3 "
                        id="leaveTypeTabs"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {leavetype.map((item, index) => (
                          <li className="nav-item" key={index}>
                            <button
                              className={`nav-link ${
                                index === 0 ? "active" : ""
                              }`}
                              id={`leaveType-${index}-tab`}
                              data-bs-toggle="tab"
                              data-bs-target={`#leaveType-${index}`}
                              type="button"
                              onClick={() => setActiveFormTab(item.label)}
                              style={{
                                backgroundColor:
                                  activeFormTab === item.label
                                    ? "#2e3294"
                                    : "transparent",
                                color:
                                  activeFormTab === item.label
                                    ? "#ffffff"
                                    : "#2e3294",
                                border: "1px solid #2e3294",
                                // border: "1px solid",
                                // borderColor:
                                //   activeFormTab === item.label
                                //     ? "#F89520"
                                //     : "#ddd",
                              }}
                            >
                              {item.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content" id="leaveTypeTabsContent">
                      {leavetype.map((item, index) => (
                        <div
                          className={`tab-pane fade ${
                            index === 0 ? "show active" : ""
                          }`}
                          id={`leaveType-${index}`}
                          role="tabpanel"
                          aria-labelledby={`leaveType-${index}-tab`}
                          key={index}
                        >
                          {/* Conditional rendering for each component */}
                          {item.component === "first component" && (
                            <form
                              className="ms-2 needs-validation"
                              noValidate
                              onSubmit={submitBussinessCardRequest}
                            >
                              <div className="mb-3 row ">
                                <label className="col-form-label col-md-3">
                                  Employee Name:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Full Name"
                                    name="emp_name"
                                    // onChange={getInputDataBussinesscard}
                                    required
                                    value={
                                      employeeData?.data.employee_name || ""
                                    }
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter the employee's full name.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Email ID:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Email Id"
                                    name="email"
                                    // onChange={getInputDataBussinesscard}
                                    required
                                    value={employeeData?.data.email_id || ""}
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter a valid email address.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Phone Number:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Phone Number"
                                    name="phone"
                                    // onChange={getInputDataBussinesscard}
                                    required
                                    value={
                                      employeeData?.data.contact_number || ""
                                    }
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter a valid phone number.
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Office Address:
                                </label>
                                <div className="col-md-8">
                                  <select
                                    className="form-select"
                                    name="address"
                                    onChange={getInputDataBussinesscard}
                                    required
                                    value={bussinessCardData.address}
                                  >
                                    <option disabled value="">
                                      Select Office Address
                                    </option>
                                    {officeAddressResponse?.data?.map(
                                      (item, index) => (
                                        <option
                                          value={item.address_id}
                                          key={index}
                                        >
                                          {item.address_name}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                  <div className="invalid-feedback">
                                    Please select an office address.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  No. of Cards:
                                </label>
                                <div className="col-md-8">
                                  <select
                                    className="form-select"
                                    name="numberofcard"
                                    onChange={getInputDataBussinesscard}
                                    value={bussinessCardData.numberofcard}
                                    required
                                  >
                                    <option disabled value="">
                                      Select No. of Cards
                                    </option>
                                    <option>50</option>
                                    <option>100</option>
                                  </select>
                                  <div className="invalid-feedback">
                                    Please select the number of cards.
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-light me-2"
                                  data-bs-dismiss="modal"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary custom_button"
                                >
                                  Send Request
                                </button>
                              </div>
                            </form>
                          )}

                          {item.component === "second component" && (
                            <form
                              action="POST"
                              className="ms-2 needs-validation"
                              noValidate
                              onSubmit={submitIDCardRequest}
                            >
                              <div className="mb-3 row ">
                                <label className="col-form-label col-md-3">
                                  Employee ID:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Employee ID"
                                    name="employee_id"
                                    // onChange={getIdCardInputData}
                                    required
                                    value={employeeData?.data.employee_id || ""}
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter a valid Employee ID.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row ">
                                <label className="col-form-label col-md-3">
                                  Employee Name:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Employee Name"
                                    name="employee_name"
                                    // onChange={getIdCardInputData}
                                    required
                                    value={
                                      employeeData?.data.employee_name || ""
                                    }
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter the Employee Name.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Blood Group:
                                </label>
                                <div className="col-md-8">
                                  <select
                                    className="form-select"
                                    name="blood_group"
                                    onChange={getIdCardInputData}
                                    required
                                    value={idCardData.blood_group}
                                  >
                                    <option value="">Select Blood Group</option>
                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="AB+">AB+</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                  </select>
                                  <div className="invalid-feedback">
                                    Please select a valid Blood Group.
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Contact No.:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Emergency Contact No."
                                    name="emergency_no"
                                    // onChange={getIdCardInputData}
                                    required
                                    value={
                                      employeeData?.data.contact_number || ""
                                    }
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter a valid Emergency Contact
                                    Number.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Department:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Department:"
                                    name="department"
                                    // onChange={getIdCardInputData}
                                    required
                                    value={employeeData?.data.department || ""}
                                    readOnly
                                  />
                                  <div className="invalid-feedback">
                                    Please enter the Department.
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Reason for Request:
                                </label>
                                <div className="col-md-8">
                                  <select
                                    className="form-select"
                                    name="reason_id"
                                    onChange={getIdCardInputData}
                                    required
                                    value={idCardData.reason_id}
                                  >
                                    <option disabled value="">
                                      Select Reason for Request
                                    </option>
                                    {idCardLossReasonResponse?.data?.map(
                                      (item, index) => (
                                        <option
                                          value={item.reason_id}
                                          key={index}
                                        >
                                          {item.reason}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                  <div className="invalid-feedback">
                                    Please select a reason for the request.
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-light me-2"
                                  data-bs-dismiss="modal"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary custom_button"
                                >
                                  Send Request
                                </button>
                              </div>
                            </form>
                          )}

                          {item.component === "third component" && (
                            <form
                              action="POST"
                              className="ms-2 needs-validation"
                              noValidate
                              onSubmit={submitMeetingRoomRequest}
                            >
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Booking Date:
                                </label>
                                <div className="col-md-8">
                                  <div className="input-icon-end position-relative">
                                    <DatePicker
                                      className="form-control datetimepicker"
                                      format={{
                                        format: "DD-MM-YYYY",
                                        type: "mask",
                                      }}
                                      value={
                                        meetingRoomData.booking_date
                                          ? dayjs(
                                              meetingRoomData.booking_date,
                                              "YYYY-MM-DD",
                                            )
                                          : null
                                      }
                                      onChange={(date) =>
                                        getBookMeetingData({
                                          target: {
                                            name: "booking_date",
                                            value: date
                                              ? date.format("YYYY-MM-DD")
                                              : "",
                                          },
                                        } as React.ChangeEvent<HTMLInputElement>)
                                      }
                                      placeholder="DD-MM-YYYY"
                                      getPopupContainer={getModalContainer}
                                      disabledDate={(current) =>
                                        current &&
                                        current.isBefore(dayjs().startOf("day"))
                                      }
                                    />
                                    <span className="input-icon-addon">
                                      <i className="ti ti-calendar text-gray-7" />
                                    </span>
                                  </div>
                                  <div className="invalid-feedback">
                                    Please select a booking date.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Start Time:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="start_time"
                                    onChange={getBookMeetingData}
                                    required
                                    value={meetingRoomData.start_time}
                                  />
                                  <div className="invalid-feedback">
                                    Please enter a start time.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  End Time:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="end_time"
                                    onChange={getBookMeetingData}
                                    required
                                    value={meetingRoomData.end_time}
                                  />
                                  <div className="invalid-feedback">
                                    Please enter an end time.
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Purpose of Booking:
                                </label>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Purpose of Booking"
                                    name="booking_purpose"
                                    onChange={getBookMeetingData}
                                    required
                                    value={meetingRoomData.booking_purpose}
                                  />
                                  <div className="invalid-feedback">
                                    Please enter the purpose of the booking.
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-form-label col-md-3">
                                  Meeting Room Name:
                                </label>
                                <div className="col-md-8">
                                  <select
                                    className="form-select"
                                    name="room_id"
                                    onChange={getBookMeetingData}
                                    required
                                    value={meetingRoomData.room_id}
                                  >
                                    <option disabled value="">
                                      Select Meeting Room
                                    </option>
                                    {meetingRoomResponse?.data?.map(
                                      (item, index) => (
                                        <option
                                          value={item.room_id}
                                          key={index}
                                        >
                                          {item.room_name}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                  <div className="invalid-feedback">
                                    Please select a meeting room.
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-light me-2"
                                  data-bs-dismiss="modal"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary custom_button"
                                >
                                  Send Request
                                </button>
                              </div>
                            </form>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </form> */}
          </div>
        </div>
      </div>
      {/* Add Form */}

      {/* Bussiness Card */}
      <div
        className="modal fade"
        id="editBusiness_Card_Request"
        ref={businessCardModalRefEdit}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="staticBackdropLabel2">
                Edit Business Card Request
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editBusinessCard"
              />
            </div>
            <div className="modal-body">
              <form
                action="POST"
                className="ms-2 needs-validation"
                noValidate
                onSubmit={upDateBussinessCard}
              >
                <div className="mb-3 row ">
                  <label className="col-form-label col-md-3">
                    Employee Name:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Full Name"
                      value={selectedRowData?.employee_name || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          employee_name: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter the employee's full name.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">Email ID:</label>
                  <div className="col-md-8">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Email Id"
                      value={selectedRowData?.email_id || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          email_id: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter a valid email address.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Phone Number:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Phone Number"
                      value={selectedRowData?.phone || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          phone: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter a valid phone number.
                    </div>
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Office Address:
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-select"
                      value={selectedRowData?.office_address_id || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          office_address_id: e.target.value,
                        })
                      }
                    >
                      <option disabled value="">
                        Select Office Address
                      </option>
                      {officeAddressResponse?.data?.map((item, index) => (
                        <option value={item.address_id} key={index}>
                          {item.address_name}
                        </option>
                      ))}
                    </select>

                    <div className="invalid-feedback">
                      Please select an office address.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    No. of Cards:
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-select"
                      value={selectedRowData?.noofcards || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          noofcards: e.target.value,
                        })
                      }
                    >
                      <option disabled value="">
                        Select No. of Cards
                      </option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                    <div className="invalid-feedback">
                      Please select the number of cards.
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-cancel"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Bussiness Card */}

      {/* Id Card */}
      <div
        className="modal fade"
        id="edit_id_Card_Request"
        ref={IdCardModalRefEdit}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="staticBackdropLabel2">
                Edit ID Card Request
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editIDCard"
              />
            </div>
            <div className="modal-body">
              <form
                action="POST"
                className="ms-2 needs-validation"
                noValidate
                onSubmit={upDateIdCard}
              >
                <div className="mb-3 row ">
                  <label className="col-form-label col-md-3">
                    Employee ID:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Employee ID"
                      value={selectedRowData?.emp_id || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          emp_id: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter a valid Employee ID.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row ">
                  <label className="col-form-label col-md-3">
                    Employee Name:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Employee Name"
                      value={selectedRowData?.employee_name || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          employee_name: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter the Employee Name.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Blood Group:
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-control"
                      value={selectedRowData?.blood_group || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          blood_group: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled>
                        Select Blood Group
                      </option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                    <div className="invalid-feedback">
                      Please select a valid Blood Group.
                    </div>
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Emergency Contact No.:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Emergency Contact No."
                      value={selectedRowData?.emergency_no || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          emergency_no: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter a valid Emergency Contact Number.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">Department:</label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Department:"
                      value={selectedRowData?.department || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          department: e.target.value,
                        })
                      }
                      readOnly
                    />
                    <div className="invalid-feedback">
                      Please enter the Department.
                    </div>
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Reason for Request:
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-select"
                      value={selectedRowData?.reason_id || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          reason_id: e.target.value,
                        })
                      }
                    >
                      <option disabled value="">
                        Select Reason for Request
                      </option>
                      {idCardLossReasonResponse?.data?.map((item, index) => (
                        <option value={item.reason_id} key={index}>
                          {item.reason}
                        </option>
                      ))}
                    </select>
                    <div className="invalid-feedback">
                      Please select a reason for the request.
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-cancel"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Id Card */}

      {/* Meeting Room */}
      <div
        className="modal fade"
        id="edit_Book_meeting_room"
        ref={BookModalRefEdit}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="staticBackdropLabel2">
                Edit Book Meeting Room
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editBookMeeting"
              />
            </div>
            <div className="modal-body">
              <form
                action="POST"
                className="ms-2 needs-validation"
                noValidate
                onSubmit={upDateMeetingRoom}
              >
                {/* <div className="mb-3 row ">
                  <label className="col-form-label col-md-3">
                    Employee Name:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Employee Name"
                      value={employeeData?.data.employee_name}
                      readOnly
                    />
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Department:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Department:"
                      value={employeeData?.data.sub_department}
                      readOnly
                    />
                  </div>
                </div> */}
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Booking Date:
                  </label>
                  <div className="col-md-8">
                    <div className="input-icon-end position-relative">
                      <DatePicker
                        className="form-control datetimepicker"
                        format={{
                          format: "DD-MM-YYYY",
                          type: "mask",
                        }}
                        value={
                          selectedRowData?.booking_date
                            ? dayjs(selectedRowData.booking_date, "YYYY-MM-DD")
                            : null
                        }
                        onChange={(date) =>
                          setSelectedRowData({
                            ...selectedRowData,
                            booking_date: date ? date.format("YYYY-MM-DD") : "",
                          })
                        }
                        getPopupContainer={getModalContainer}
                        placeholder="DD-MM-YYYY"
                        disabledDate={(current) =>
                          current && current.isBefore(dayjs().startOf("day"))
                        }
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">Start Time:</label>
                  <div className="col-md-8">
                    <input
                      type="time"
                      className="form-control"
                      value={selectedRowData?.start_time || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          start_time: e.target.value,
                        })
                      }
                    />
                    <div className="invalid-feedback">
                      Please choose a username.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">End Time:</label>
                  <div className="col-md-8">
                    <input
                      type="time"
                      className="form-control"
                      value={selectedRowData?.end_time || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          end_time: e.target.value,
                        })
                      }
                    />
                    <div className="invalid-feedback">
                      Please choose a username.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Purpose of Booking:
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Purpose of Booking:"
                      value={selectedRowData?.booking_purpose || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          booking_purpose: e.target.value,
                        })
                      }
                    />
                    <div className="invalid-feedback">
                      Please choose a username.
                    </div>
                  </div>
                </div>
                <div className="mb-3 row">
                  <label className="col-form-label col-md-3">
                    Meeting Room Name:
                  </label>
                  <div className="col-md-8">
                    <select
                      className="form-select"
                      value={selectedRowData?.room_id || ""}
                      required
                      onChange={(e) =>
                        setSelectedRowData({
                          ...selectedRowData,
                          room_id: e.target.value,
                        })
                      }
                    >
                      <option disabled value="">
                        Select Meeting Room
                      </option>
                      {meetingRoomResponse?.data?.map((item, index) => (
                        <option value={item.room_id} key={index}>
                          {item.room_name}
                        </option>
                      ))}
                    </select>
                    <div className="invalid-feedback">
                      Please choose a username.
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-cancel"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Meeting Room */}
    </>
  );
};

export default SelfHelp;
